export interface CategoryStepProps {
  isSmallerDevices: boolean;
}

export enum StepType {
  CLOTHING = 'clothing',
  SHOES = 'shoes',
}

export enum ActionType {
  ENTER_DETAILS = 'enter_details',
  DELETE_PROFILE = 'delete_profile',
}
